import sortable from "html5sortable/dist/html5sortable.es";

/* expects each sortable item(each element in the container with the sortable class), to have a data.path pointing to the action to take when an item has been moved. */

document.addEventListener('DOMContentLoaded', function () {
  document.getElementsByClassName("btn-toggle")

  const sortableElements = sortable("[data-sortable=true]", {
    placeholderClass: "options-list-sortable-placeholder",
    acceptFrom: "[data-sortable=true]",
    items: '.sort-item'
  })

  let sortingData = []
  const form = setupSortableSubmitForm()

  for(let sortableElement of sortableElements){
    sortableElement.addEventListener("sortstart" , e => {
      document.querySelectorAll("[data-sortable]").forEach(container => {
        container.classList.add("sorting");
        container.querySelectorAll(".collapse").forEach(element => {
          element.classList.add("show")
        })
        container.querySelectorAll("[aria-expanded]").forEach(element => {
          element.setAttribute("aria-expanded","true");
        })
      })
    })

    sortableElement.addEventListener("sortstop" , e => {
      document.querySelectorAll("[data-sortable]").forEach(container => {
        container.classList.remove("sorting");
      })
    })

    sortableElement.addEventListener('sortupdate', async function(e) {
      let immediateSubmitPath = e.detail.item.dataset.path
      let sortableId = e.detail.item.dataset.sortableId;
      let position = e.detail.destination.index+1;
      let parentId = e.detail.destination.container.dataset.parentId;

      if(immediateSubmitPath) {
        // Item has an path parameter, meaning immediate position can be submitted
        form.setAttribute('action', immediateSubmitPath)
        setParameter('position', position, form)
        setParameter('_method', 'put', form)
        if (parentId) setParameter('parent_id', parentId, form);

        form.submit();
      } else {
        // Changes to item order is submitted in a batch when the form is explicitly submitted.
        sortingData = updateSortingData(sortingData, sortableId, position, parentId)
        setParameter('sorting-data', JSON.stringify(sortingData), form)

        let submitButton = document.querySelector("#sortableFormSubmit")
        form.setAttribute('action', submitButton.dataset.path)
        setParameter('_method', 'post', form)

        if(submitButton) submitButton.classList.remove("d-none")

        setupUnsavedChangesListener(submitButton)
      }
    });
  }

});
let setupSortableSubmitForm = () => {
  const form = document.createElement('form')
  let csrfParam = document.querySelector('meta[name=csrf-param]').getAttribute('content')
  let csrfToken = document.querySelector('meta[name=csrf-token]').getAttribute('content')
  form.setAttribute("id", "sortableForm");
  form.setAttribute('method', 'post')
  setParameter("sorting-data", "[]", form)
  setParameter(csrfParam, csrfToken, form)
  form.style.display = 'none'
  document.body.appendChild(form)

  return form
}

let setParameter = (name, value, form) => {
  let parameter = form.querySelector(`input[name="${name}"]`)
  if(!parameter) {
    parameter = document.createElement('input')
    parameter.setAttribute('name', name)
    parameter.setAttribute('value', `${value}`)
    form.appendChild(parameter)
  } else {
    parameter.setAttribute('value', `${value}`)
  }
}

let updateSortingData = (sortingData, sortableId, position, parentId) => {
  let existing = sortingData.find(x => x.id === sortableId)

  if(existing) {
    let sliceIndex = sortingData.indexOf(existing)
    sortingData.splice(sliceIndex, 1)
    existing.position = position
    existing.parentId = parentId

    sortingData.push(existing)
  } else {
    sortingData.push({id: sortableId, position: position, parentId: parentId})
  }

  return sortingData
}

let setupUnsavedChangesListener = (submitButton) => {
  let areYouSureFunc = function (e) {
    event.returnValue = ""; // Custom messages are not accepted anymore
    return ""; // Webkit, Safari, Chrome etc.
  }

  window.addEventListener("beforeunload", areYouSureFunc);

  submitButton.addEventListener("click", (event) => {
    window.removeEventListener("beforeunload", areYouSureFunc);
  })
}